import api from "./Api";

class InutilizacaoNFeService {
  GetInutilizacaoNFe(payload) {
    return api.get("/v1/InutilizacaoNFe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostInutilizacaoNFe(payload) {
    return api.post("/v1/InutilizacaoNFe/", payload).then((response) => {
      return response.data;
    });
  }

  PutInutilizacaoNFe(payload) {
    return api.put("/v1/InutilizacaoNFe/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteInutilizacaoNFe(payload) {
    return api.delete("/v1/InutilizacaoNFe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetInutilizacaoNFeOData(payload) {
    return api.get("/OData/InutilizacaoNFe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new InutilizacaoNFeService();
